module.exports = "<!--<div class=\"container\">\n  <app-header></app-header>\n\n  <router-outlet></router-outlet>\n\n  <app-footer></app-footer>\n</div>-->\n\n<!--<app-header></app-header>-->\n<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = 738
// module chunks = 1